import React from "react";
import valueImage from "../images/value of proposition.png";

const ValuePropositions = () => {
  return (
    <section className="py-20 border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div data-aos="fade-right">
            <span className="text-xs uppercase tracking-widest font-bold text-[#EB4438] bg-red-50 px-3.5 py-1.5 rounded-full border border-red-100">
              Why Choose Us
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 mb-6 tracking-tight">
              Value Propositions
            </h2>
            <p className="text-justify text-slate-600 text-sm sm:text-base leading-relaxed">
              By continuing to widen our network and deepening our sector
              specific expertise, The Dynamic Export Import Company Ltd. of
              companies aim to strengthen value proposition future by providing
              a greater range of integrated business solution across the focused
              industries and markets. In short, Our value proposition is
              succinctly in three points, forming one powerful statement:
            </p>

            <ul className="mt-8 space-y-4">
              <li className="p-4 rounded-xl border border-slate-200/80 bg-slate-50/50 flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-[#EB4438] mt-2 shrink-0"></span>
                <span className="text-sm sm:text-base text-slate-700">
                  <span className="font-bold text-slate-900">Convenience</span> : One stop
                  provider of integrated solution.
                </span>
              </li>
              <li className="p-4 rounded-xl border border-slate-200/80 bg-slate-50/50 flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-[#EB4438] mt-2 shrink-0"></span>
                <span className="text-sm sm:text-base text-slate-700">
                  <span className="font-bold text-slate-900">Assurance</span> : Delivering
                  quality products and services.
                </span>
              </li>
              <li className="p-4 rounded-xl border border-slate-200/80 bg-slate-50/50 flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-[#EB4438] mt-2 shrink-0"></span>
                <span className="text-sm sm:text-base text-slate-700">
                  <span className="font-bold text-slate-900">Network</span> : Leveraging our
                  global Network.
                </span>
              </li>
            </ul>
          </div>

          <div className="flex justify-center" data-aos="fade-left">
            <div className="p-6 rounded-3xl bg-white border border-slate-200/80 shadow-md">
              <img
                src={valueImage}
                alt="Value proposition diagram"
                className="max-h-96 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuePropositions;

